import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { mapGraphQLErrors } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { Schema } from '../../schema'
import { toDTO } from './api/mapper'
import { UPDATE_GAM_ORDER_RETARGETING_DEALS_DELIVERY } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdateGamOrderRetargetingDealsDelivery } from './types'

export const useUpdateGamOrderRetargetingDealsDelivery =
  (): UseUpdateGamOrderRetargetingDealsDelivery => {
    const { t } = useTranslation('features/globalSetup', {
      keyPrefix: 'googleAdManagerConnection.setupRetargetingDeliveryItems.form.update',
    })
    const { enqueueSnackbar } = useSnackbar()
    const [errors, setErrors] = useState<FieldErrors<Schema>>({})

    const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
      mutation: UPDATE_GAM_ORDER_RETARGETING_DEALS_DELIVERY,
      onCompleted: async (data: Data): Promise<void> => {
        const {
          connectRetargetingDealsDeliveryToGam: { errors },
        } = data

        if (errors && errors.length > 0) {
          setErrors(mapGraphQLErrors(errors))
          enqueueSnackbar(t('error'), { variant: 'error' })
        } else {
          enqueueSnackbar(t('success'), { variant: 'success' })
        }
      },
      queriesToInvalidate: ['getFreshStatusAndErrorForGamRetargeting'],
    })

    const update = (variables: Schema): void => {
      void mutateAsync({
        input: toDTO(variables),
      })
    }

    return {
      errors,
      isPending,
      update,
    }
  }
